module.exports = __webpack_public_path__ + "img/aws-1.708e99a5.png";